import script from "./AdBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AdBanner.vue?vue&type=script&setup=true&lang=js"

import "./AdBanner.vue?vue&type=style&index=0&id=8da16632&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8da16632"]])

export default __exports__